import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';

import './appraisal-report-price-title.scss';

/**
 * Renders title with info for appraisal report.
 * @param {string} title
 * @param {string} info
 * @param {string} placement
 * @param {string} iconClassName
 * @param {object} openTrackingParams
 * @returns {ReactElement}
 */
export function AppraisalReportStepPriceTitle({
  title,
  info = '',
  placement = 'bottom',
  iconClassName = 'ms-0_5 xsmall',
  openTrackingParams = null,
}) {
  return (
    <Fragment>
      {title}&nbsp;
      {!!info && (
        <PopoverItem
          className="appraisal-table-info-btn d-inline-flex"
          iconClassName={iconClassName}
          placement={placement}
          openTrackingParams={openTrackingParams}
          screenReaderTooltipLabel={`${title} information`}
        >
          {info}
        </PopoverItem>
      )}
    </Fragment>
  );
}

AppraisalReportStepPriceTitle.propTypes = {
  info: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  placement: PropTypes.string,
  iconClassName: PropTypes.string,
  openTrackingParams: PropTypes.shape({}),
};
